// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    complaintCause: t.Bool,
    complaintCorrection: t.Bool,
    downtime: t.Bool,
    failureArea: t.Bool,
    failureDate: t.Bool,
    failureMode: t.Bool,
    failurePart: t.Bool,
    operatorsComplaint: t.Bool,
    ownershipStatus: t.Bool,
    pin: t.Bool,
    repairDate: t.Bool,
    responsibleAccount: t.Bool,
    useAmount: t.Bool,
    useAmountUnit: t.Bool,
    workOrderOne: t.Bool
}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    complaintCause: true,
    complaintCorrection: true,
    downtime: true,
    failureArea: true,
    failureDate: true,
    failureMode: true,
    failurePart: true,
    operatorsComplaint: true,
    ownershipStatus: true,
    pin: true,
    repairDate: true,
    responsibleAccount: true,
    useAmount: true,
    useAmountUnit: true,
    workOrderOne: true
});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/claim/normal/state/form-validation.js